import { lazy, Suspense } from 'react';
import { CircularProgress } from '@mui/material';

import { Switch, Route, Redirect, useRouteMatch } from 'react-router-dom';
import RoutePrivate from 'components/common/route-private';
import { config } from 'config';

const FindPlayer = lazy(() => import('components/SEARCH_TOOL/accounts/findPlayer'));
const AccountInfo = lazy(() => import('components/SEARCH_TOOL/accounts/accountInfo'));
const CS = lazy(() => import('components/SEARCH_TOOL/customerSupport'));
const GameData = lazy(() => import('components/SEARCH_TOOL/gameData'));
const PromoInviteCode = lazy(() => import('components/SEARCH_TOOL/promoInviteCode'));
const DDTourData = lazy(() => import('components/SEARCH_TOOL/ddTourData'));
const TransactionHistory = lazy(() => import('components/SEARCH_TOOL/currency/transactions'));
const TransactionHistoryRC = lazy(() => import('components/SEARCH_TOOL/currency/transactions/rc'));
const Wallet = lazy(() => import('components/SEARCH_TOOL/currency/wallet'));
const Withdrawal = lazy(() => import('components/SEARCH_TOOL/withdrawals/withdrawal'));
const UserHistory = lazy(() => import('components/SEARCH_TOOL/withdrawals/userHistory'));
const PurchaseHistory = lazy(() => import('components/SEARCH_TOOL/withdrawals/purchaseHistory'));
const DeleteHistory = lazy(() => import('components/SEARCH_TOOL/accounts/deletionHistory'));
const DevStats = lazy(() => import('components/SEARCH_TOOL/devStats'));

const SearchTool = () => {
  let { path } = useRouteMatch();

  return (
    <Suspense fallback={<CircularProgress />}>
      <Switch>
        <RoutePrivate exact path={`${path}/accounts/findplayer`} component={FindPlayer} permission='VIEWER' />
        <RoutePrivate exact path={`${path}/accounts/accountinfo`} component={AccountInfo} permission='VIEWER' />
        <RoutePrivate exact path={`${path}/accounts/accountdeletehistory`} component={DeleteHistory} permission='VIEWER' />
        <RoutePrivate exact path={`${path}/cs`} component={CS} permission='VIEWER' />
        <RoutePrivate exact path={`${path}/gamehistory`} component={GameData} permission='VIEWER' />
        <RoutePrivate exact path={`${path}/promoinvitecode`} component={PromoInviteCode} permission='VIEWER' />
        <RoutePrivate exact path={`${path}/ddtourdata`} component={DDTourData} permission='VIEWER' />
        <RoutePrivate exact path={`${path}/currency/transactions`} component={TransactionHistory} permission='VIEWER' />
        <RoutePrivate exact path={`${path}/currency/rctrx`} component={TransactionHistoryRC} permission='VIEWER' />
        <RoutePrivate exact path={`${path}/currency/wallet`} component={Wallet} permission='VIEWER' />
        <RoutePrivate exact path={`${path}/withdrawals/requests`} component={Withdrawal} permission='VIEWER' />
        <RoutePrivate exact path={`${path}/withdrawals/userhistory`} component={UserHistory} permission='VIEWER' />
        <RoutePrivate exact path={`${path}/withdrawals/purchasehistory`} component={PurchaseHistory} permission='VIEWER' />
        <RoutePrivate exact path={`${path}/devstats`} component={DevStats} permission='VIEWER' />

        <Route path='*'>
          <Redirect to={`/${config.game}/dashboard/notfound`} />
        </Route>
      </Switch>
    </Suspense>
  );
};

export default SearchTool;
